import { es } from './es';
import { en } from './en';

export type Lang = 'es' | 'en';

export const DICTS: Record<Lang, Record<string, string>> = { es, en };

export function translate(lang: Lang, key: string): string {
  return DICTS[lang][key] ?? DICTS.es[key] ?? key;
}

export function hasKey(key: string): boolean {
  return key in es && key in en;
}

/** Claves presentes en un idioma pero no en el otro (para el test de paridad). */
export function dictParityProblems(): string[] {
  const problems: string[] = [];
  for (const k of Object.keys(es)) if (!(k in en)) problems.push(`falta en EN: ${k}`);
  for (const k of Object.keys(en)) if (!(k in es)) problems.push(`falta en ES: ${k}`);
  return problems;
}
